<template>
    <div class="allFiles">

        <!--File Thumbs List-->
        <div v-if="pagination.items.length > 0" class="grid-layout files gallery">
            <div
                v-for="(file, fileIndex) in pagination.items"
                :key="`file_${fileIndex}`"
                class="grid-item"
                :class="getDynamicClass(fileIndex)"
            >
                <div class="userFileItem">

                    <!--Video-->
                    <template v-if="file.type === 'video'">
                        <div class="video image" :style="`background-image:url(${file.poster.url});`">
                            <div 
                                class="galleryItem"
                                @click.prevent="
                                    lightbox.index = fileIndex
                                    lightbox.show = true
                                "
                            >
                                <!-- <video controls :src="`${file.url}`" :poster="file.poster.url"></video>-->
                                <ion-icon name="play"></ion-icon>
                            </div>
                        </div>
                    </template>

                    <!--Image-->
                    <template v-else-if="file.type === 'image'">
                        <div class="image" :style="`background-image:url(${file.medium.url});`">
                            <div
                                class="galleryItem"
                                @click.prevent="
                                    lightbox.index = fileIndex
                                    lightbox.show = true
                                "
                            ></div>
                        </div>
                    </template>

                    <!--Other-->
                    <template v-else-if="file.type === 'other'">
                        <div 
                            class="doc"
                            @click.prevent="
                                lightbox.index = fileIndex
                                lightbox.show = true
                            "
                        >
                            <ion-icon name="document"></ion-icon>
                        </div>
                    </template>

                    <!--File Actions-->
                    <div class="fileActions">
                        <!-- <a @click.prevent="editFile(file)" class="iconBtnCircle">
                            <ion-icon name="pencil"></ion-icon>
                        </a> -->
                        <a
                            @click.prevent="deleteFile(file)"
                            class="iconBtnCircle"
                        >
                            <ion-icon name="trash"></ion-icon>
                        </a>
                        <!-- <a @click.prevent="toggleFileMenu" class="iconBtnCircle">
                            <ion-icon name="ellipsis-horizontal"></ion-icon>
                        </a> -->
                    </div>
                </div>
            </div>
        </div>
        <div v-if="pagination.hasMore || pagination.loading" class="moreArea">
            <a v-if="pagination.hasMore && !pagination.loading" href="#0" @click.prevent="getItems('more')" class="btn secondary">Load More</a>
            <div v-if="pagination.loading" class="loading small no-margin"></div>
        </div>

        <!--Lightbox-->
        <div class="gallery-lightbox">
            <LightBox
                ref="files"
                :media="lightboxFiles"
                :showLightBox="true"
                :startAt="lightbox.index"
                v-if="lightbox.show"
                @onClosed="lightbox.show = false"
            >
                <template slot="close">
                    <ion-icon name="close"></ion-icon>
                </template>
                <template slot="previous">
                    <ion-icon name="arrow-back"></ion-icon>
                </template>
                <template slot="next">
                    <ion-icon name="arrow-forward"></ion-icon>
                </template>
                <!-- <template slot="customCaption">
                    <div class="caption">
                        <h3>Image Title</h3>
                    </div>
                </template> -->
            </LightBox>
        </div>
    </div>
</template>

<script>
const fb = require('@/firebaseConfig.js')
import FileUpload from '@/components/uploader/FileUpload'
import LightBox from 'vue-image-lightbox'

export default {
    name: 'Files',

    data(){
        return{
            pagination: {
                start: null,
                items: [],
                next: [],
                page: 1,
                hasMore: false,
                loading: false,
                orderBy: 'timestamp',
                limit: 9
            },
            lightbox: {
                index: 0,
                show: false
            }
        }
    },

    components: {
        FileUpload,
        LightBox
    },

    async created(){
        if(this.$store.state.currentUser !== null){
            this.ref = fb.usersCollection.doc(this.$store.state.currentUser.uid).collection('files')
            await this.getItems('first')
        }
    },

    computed: {
        lightboxFiles(){
            let galleryItems = []
            
            for(let i = 0; i < this.pagination.items.length; i++){
                let file = this.pagination.items[i]
                
                if(file.type === 'image'){
                    galleryItems.push({
                        id: file.uid,
                        thumb: file.small.url,
                        src: file.original.url,
                        caption: file.name,
                        provider: 'OneMgl'
                    })
                }else if(file.type === 'video'){
                    galleryItems.push({
                        id: file.uid,
                        thumb: file.poster.url,
                        sources: [{
                            src: file.url,
                            type: file.fileType
                        }],
                        caption: file.name,
                        provider: 'OneMgl',
                        type: 'video',
                        width: '100%',
                        height: 650,
                        autoplay: true
                    })
                }
            }

            return galleryItems
        }
    },

    methods: {
        reset(){
            this.pagination = {
                start: null,
                items: [],
                next: [],
                orderBy: 'timestamp',
                limit: 9,
                page: 1,
                hasMore: false,
                loading: false
            }

            this.lightbox = {
                index: 0,
                show: false
            }
        },
        deleteFile(file){
            if(confirm('Are you sure you want to delete this file?')){
                this.$emit('delete-file', file)
            }
        },
        getDynamicClass(index){
            let currentIndex = index + 1
            let dynamicClass = `grid-item-${currentIndex} `
            
            if(currentIndex === 3 || currentIndex === 17 || currentIndex === 26 || currentIndex === 40 || currentIndex === 45){
                dynamicClass += 'span-2 '
            }
            if(currentIndex === 5 || currentIndex === 10 || currentIndex === 13 || currentIndex === 21){
                dynamicClass += 'span-2 '
            }

            return dynamicClass
        },

        // Get Paginated Items
        async getItems(type){
            // Initial Load
            if(type === 'first'){
                this.pagination.loading = true

                let ref = this.ref.orderBy(this.pagination.orderBy, 'desc').limit(this.pagination.limit)

                await ref.onSnapshot(async(snap) => {
                    if(snap.docs.length > 0){
                        
                        this.pagination.items = []
                        this.pagination.next = []
                        this.pagination.page = 1

                        snap.forEach(doc => {
                            this.pagination.items = this.pagination.items.filter(x => x.uid !== doc.uid)
                            this.pagination.items.push(doc.data())
                        })

                        this.pagination.start = snap.docs[snap.docs.length - 1]
                        this.pagination.hasMore = false
                        this.pagination.loading = false

                        await this.getItems('next')
                    }else{
                        this.pagination.hasMore = false
                        this.pagination.loading = false
                    }
                })

            // Load More from next checked batch
            }else if(type === 'more'){
                this.pagination.loading = true
                
                if(this.pagination.next.length > 0){
                    this.pagination.page += 1

                    this.pagination.next.forEach(file => {
                        this.pagination.items = this.pagination.items.filter(x => x.uid !== file.uid)
                        this.pagination.items.push(file)
                    })
                    
                    this.pagination.loading = false
                    this.pagination.next = []

                    this.getItems('next')
                }else{
                    this.pagination.loading = false
                    this.pagination.hasMore = false
                }

            // Check and get more
            }else if(type === 'next'){
                this.pagination.hasMore = false

                let ref = this.ref.orderBy(this.pagination.orderBy, 'desc').startAfter(this.pagination.start).limit(this.pagination.limit)

                await ref.get().then(async(snap) => {
                    if(snap.docs.length > 0){
                        
                        snap.forEach(doc => {
                            this.pagination.next.push(doc.data())
                        })

                        this.pagination.start = snap.docs[snap.docs.length - 1]
                        this.pagination.hasMore = true

                    }else{
                        this.pagination.hasMore = false
                        this.pagination.loading = false
                    }
                })
            }
        },
    }
}
</script>


// WEBPACK FOOTER //
// src/components/user/Files.vue